exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".omb_spanOr {\n  color: #bfbfbf !important;\n  float: left;\n  font-size: 16px;\n  font-weight: bold;\n  margin-bottom: 11px;\n  margin-top: 10px;\n  text-align: center;\n  width: 100%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/app/components/auth/assets/css/style.css
// module id = 1102
// module chunks = 0